import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_Scale } from "./XML_Scale";

export function XML_FillRectPDF(x, y, width, height, fillColor, fillColor2, drawElement, layer) {
  x = XML_ScaleAndShiftX(x, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);
  width = XML_Scale(width, drawElement, layer);
  height = XML_Scale(height, drawElement, layer);
  y = drawElement.ConvertY(y);
  drawElement.DoFillRect(x, y, width, height, fillColor, fillColor2);
}
